<template>
  <div style="padding: 20px">
    <el-card>
      <template #header>
        <div style="display:flex;justify-content:space-between;align-items:center">
          <span>任务管理</span>
          <div>
            <el-button size="small" type="primary" @click="openPublish">下发任务</el-button>
            <el-button size="small" @click="tplVisible = true">任务模板</el-button>
            <el-button size="small" @click="openRules">催办规则</el-button>
            <el-button size="small" type="warning" @click="urgeOverdue">逾期催办</el-button>
            <el-button size="small" @click="summary">提交情况汇总</el-button>
          </div>
        </div>
      </template>

      <el-form :inline="true" @submit.prevent>
        <el-form-item label="标题">
          <el-input v-model="query.title" placeholder="任务标题" clearable style="width:160px" />
        </el-form-item>
        <el-form-item label="发布人">
          <el-input v-model="query.publisherName" placeholder="发布人姓名" clearable style="width:140px" />
        </el-form-item>
        <el-form-item label="接收人">
          <el-input v-model="query.receiverName" placeholder="接收人姓名" clearable style="width:140px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="tableData" border v-loading="loading" style="width:100%">
        <el-table-column prop="task.id" label="ID" width="80" />
        <el-table-column prop="task.title" label="标题" min-width="160" />
        <el-table-column prop="task.content" label="任务内容" min-width="200" show-overflow-tooltip />
        <el-table-column prop="publisherName" label="发布人" width="120" />
        <el-table-column label="提交进度" width="110">
          <template #default="{row}">{{ row.submittedCount }}/{{ row.receiverCount }}</template>
        </el-table-column>
        <el-table-column prop="task.status" label="状态" width="100">
          <template #default="{row}">{{ ['','已下发','进行中','已提交','已完成','已归档','延期未操作'][row.task.status] || row.task.status }}</template>
        </el-table-column>
        <el-table-column prop="task.deadline" label="截止" width="160" />
        <el-table-column label="操作" width="200" fixed="right">
          <template #default="{row}">
            <el-button size="small" @click="urgeSubmit(row.task.id)">催交</el-button>
            <el-button size="small" type="primary" @click="goDetail(row.task.id)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination style="margin-top:12px" background layout="total, sizes, prev, pager, next, jumper"
        :total="total" :current-page="query.page" :page-size="query.size" :page-sizes="[10, 20, 50, 100]"
        @current-change="onPage" @size-change="onSize" />
    </el-card>

    <el-dialog v-model="detailVisible" title="任务接收详情" width="820px">
      <el-table :data="detailList" border v-loading="detailLoading">
        <el-table-column prop="receiver.receiverId" label="接收人ID" width="100" />
        <el-table-column prop="receiverName" label="接收人" width="120" />
        <el-table-column label="状态" width="110">
          <template #default="{row}">{{ recvStatus(row.receiver.receiveStatus) }}</template>
        </el-table-column>
        <el-table-column label="催办次数" width="90">
          <template #default="{row}">{{ (row.receiver.urgeCount != null ? row.receiver.urgeCount : 0) + ' 次' }}</template>
        </el-table-column>
        <el-table-column prop="receiver.receiveTime" label="接收/提交时间" width="160" />
        <el-table-column label="操作" width="100">
          <template #default="{row}">
            <el-button size="small" @click="viewSubmission(row)">看提交</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog v-model="subVisible" title="提交内容" width="680px" append-to-body class="sub-dialog">
        <div v-if="subRecord" v-loading="false">
          <el-descriptions :column="1" border size="small">
            <el-descriptions-item label="提交人">{{ subRecord.submitterName || ('#' + (subRecord.receiver && subRecord.receiver.receiverId)) }}</el-descriptions-item>
            <el-descriptions-item label="提交时间">{{ subRecord.submission && subRecord.submission.submitTime ? fmtTime(subRecord.submission.submitTime) : '-' }}</el-descriptions-item>
            <el-descriptions-item label="期 / 阶段">{{ periodStageText(subRecord) }}</el-descriptions-item>
            <el-descriptions-item label="提交类型">{{ submitTypeText(subRecord.submission && subRecord.submission.submissionType) }}</el-descriptions-item>
            <el-descriptions-item label="文本反馈">
              <span v-if="subRecord.submission && subRecord.submission.textContent" class="pre-wrap">{{ subRecord.submission.textContent }}</span>
              <span v-else>（无）</span>
            </el-descriptions-item>
            <el-descriptions-item label="附件">
              <div v-if="attachItems.length" class="attach-list">
                <div v-if="attachImageUrls.length" class="attach-imgs">
                  <el-image
                    v-for="(img, i) in attachImageUrls" :key="img"
                    :src="img" fit="cover" class="attach-thumb"
                    :preview-src-list="attachImageUrls" :initial-index="i" preview-teleported
                    hide-on-click-modal>
                  </el-image>
                </div>
                <div v-for="f in attachDocItems" :key="f.url" class="attach-file">
                  <a :href="f.url" target="_blank" rel="noopener">
                    <span class="attach-file__name">{{ f.name }}</span>
                    <span class="attach-file__open">点击查看</span>
                  </a>
                </div>
              </div>
              <span v-else>（无）</span>
            </el-descriptions-item>
            <el-descriptions-item label="审核状态">{{ reviewStatusText(subRecord.submission && subRecord.submission.reviewStatus) }}</el-descriptions-item>
            <el-descriptions-item label="评分">{{ (subRecord.submission && subRecord.submission.score) != null ? subRecord.submission.score : '（未评）' }}</el-descriptions-item>
            <el-descriptions-item label="评语">{{ (subRecord.submission && subRecord.submission.reviewComment) || '（无）' }}</el-descriptions-item>
            <el-descriptions-item label="审核时间">{{ (subRecord.submission && subRecord.submission.reviewTime) ? fmtTime(subRecord.submission.reviewTime) : '-' }}</el-descriptions-item>
          </el-descriptions>
          <div v-if="formDataRows.length" style="margin-top:12px">
            <div class="sub-title">表单数据</div>
            <el-descriptions :column="1" border size="small">
              <el-descriptions-item v-for="f in formDataRows" :key="f.k" :label="f.k">{{ f.v }}</el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
        <el-empty v-else description="暂无提交" />
      </el-dialog>
    </el-dialog>

    <!-- 任务模板库（B2） -->
    <el-dialog v-model="tplVisible" title="任务模板库" width="820px">
      <div style="display:flex;justify-content:flex-end;margin-bottom:10px">
        <el-button size="small" type="primary" @click="resetTplForm">新增模板</el-button>
      </div>
      <el-table :data="tplList" border v-loading="tplLoading" size="small">
        <el-table-column prop="title" label="模板标题" min-width="160" />
        <el-table-column label="类型" width="90">
          <template #default="{row}">{{ ['','普通任务','文档提交','表单填写'][row.taskType] || row.taskType }}</template>
        </el-table-column>
        <el-table-column label="适用阶段(结对后第n月)" min-width="200">
          <template #default="{row}">{{ monthsText(row.targetStageMonths) }}</template>
        </el-table-column>
        <el-table-column prop="content" label="内容" min-width="200" show-overflow-tooltip />
        <el-table-column prop="sort" label="排序" width="60" />
        <el-table-column label="操作" width="130">
          <template #default="{row}">
            <el-button size="small" @click="editTpl(row)">编辑</el-button>
            <el-button size="small" type="danger" @click="delTpl(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-divider />
      <div style="font-size:13px;color:#909399;line-height:1.8">
        用途：管理员/HR 在后台「下发任务」时，可按模板一键填充标题与内容，避免每次手填。<br />
        模板由管理员在此维护（增删改）；正式下发请在「下发任务」中选择模板。
      </div>
    </el-dialog>

    <!-- 模板编辑 -->
    <el-dialog v-model="tplFormVisible" :title="tplForm.id ? '编辑模板' : '新增模板'" width="560px" append-to-body>
      <el-form label-width="90px">
        <el-form-item label="标题" required>
          <el-input v-model="tplForm.title" placeholder="如：暑假班续费流程梳理" />
        </el-form-item>
        <el-form-item label="任务类型">
          <el-select v-model="tplForm.taskType" style="width:100%">
            <el-option :value="1" label="普通任务" />
            <el-option :value="2" label="文档提交" />
            <el-option :value="3" label="表单填写" />
          </el-select>
        </el-form-item>
        <el-form-item label="适用阶段">
          <el-select v-model="tplForm.targetStageMonths" multiple collapse-tags placeholder="可多选月份（空=通用）" style="width:100%">
            <el-option v-for="m in 12" :key="m" :value="m" :label="'第' + m + '个月'" />
          </el-select>
        </el-form-item>
        <el-form-item label="内容">
          <el-input v-model="tplForm.content" type="textarea" :rows="4" placeholder="任务说明/步骤，换行用 \n" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="tplForm.sort" :min="0" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="tplFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="tplSaving" @click="saveTpl">保存</el-button>
      </template>
    </el-dialog>

    <!-- 下发任务（支持按模板一键填充 / 按个人 或 按结对批量） -->
    <el-dialog v-model="publishVisible" title="下发任务" width="640px" append-to-body>
      <el-form label-width="90px">
        <el-form-item label="任务模板">
          <el-select v-model="publishForm.tplId" clearable filterable placeholder="选择模板一键填充（可再改）" style="width:100%" @change="applyTpl">
            <el-option v-for="t in tplList" :key="t.id" :value="t.id" :label="t.title" />
          </el-select>
        </el-form-item>
        <el-form-item label="标题" required>
          <el-input v-model="publishForm.title" placeholder="任务标题" />
        </el-form-item>
        <el-form-item label="内容">
          <el-input v-model="publishForm.content" type="textarea" :rows="4" placeholder="任务说明/步骤" />
        </el-form-item>
        <el-form-item label="任务类型">
          <el-select v-model="publishForm.taskType" style="width:100%">
            <el-option :value="1" label="普通任务" />
            <el-option :value="2" label="文档提交" />
            <el-option :value="3" label="表单填写" />
          </el-select>
        </el-form-item>
        <el-form-item label="适用阶段">
          <el-select v-model="publishForm.targetStageMonths" multiple collapse-tags placeholder="可多选月份（空=通用）" style="width:100%">
            <el-option v-for="m in 12" :key="m" :value="m" :label="'第' + m + '个月'" />
          </el-select>
        </el-form-item>
        <el-form-item label="截止时间">
          <el-date-picker v-model="publishForm.deadline" type="datetime" value-format="YYYY-MM-DD HH:mm:ss" placeholder="选填" style="width:100%" />
        </el-form-item>
        <el-form-item label="下发方式">
          <el-radio-group v-model="publishForm.mode">
            <el-radio label="individual">给个人（单发）</el-radio>
            <el-radio label="pair">按结对批量（每对→导师+徒弟）</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="publishForm.mode === 'individual'" label="接收人" required>
          <el-select v-model="publishForm.receiverIds" multiple filterable remote
            :remote-method="searchReceiver" :loading="coachLoading" placeholder="输入姓名/手机号搜索徒弟" style="width:100%">
            <el-option v-for="c in receiverOptions" :key="c.coachid" :value="c.coachid" :label="c.coachname + ' #' + c.coachid" />
          </el-select>
        </el-form-item>
        <el-form-item v-else label="结对" required>
          <el-select v-model="publishForm.relationIds" multiple filterable placeholder="选择若干对师徒（每对自动下发给导师+徒弟）" style="width:100%">
            <el-option v-for="r in relationOptions" :key="r.relation.id" :value="r.relation.id"
              :label="(r.mentorName || '导师#'+r.relation.mentorId) + ' → ' + (r.apprenticeName || '徒弟#'+r.relation.apprenticeId) + '（' + periodStageText(r) + '）'" />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="publishVisible = false">取消</el-button>
        <el-button type="primary" :loading="publishing" @click="doPublish">下发</el-button>
      </template>
    </el-dialog>

    <!-- 催办漏斗规则（B4） -->
    <el-dialog v-model="ruleVisible" title="催办漏斗规则（每天 09:00 自动执行，走企微 webhook）" width="640px">
      <el-table :data="ruleList" border v-loading="ruleLoading" size="small">
        <el-table-column prop="ruleName" label="规则" width="170" />
        <el-table-column label="阈值(天)" width="110">
          <template #default="{row}">
            <el-input-number v-model="row.thresholdDays" :min="0" size="small" style="width:90px" />
          </template>
        </el-table-column>
        <el-table-column label="启用" width="90">
          <template #default="{row}">
            <el-switch v-model="row.enabled" :active-value="1" :inactive-value="0" />
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="说明" />
      </el-table>
      <div style="margin-top:10px;font-size:13px;color:#909399">
        阈值说明：下发后 N 天未接收 / 接收后 N 天未提交 / 逾期即升级催办。修改后点「保存」生效。
      </div>
      <template #footer>
        <el-button @click="ruleVisible = false">关闭</el-button>
        <el-button type="primary" :loading="ruleSaving" @click="saveRules">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mentorAdminTasks, mentorAdminTaskReceivers, mentorNoticeUrgeSubmit, mentorNoticeUrgeOverdue, mentorNoticeSubmitSummary, mentorTaskTemplates, mentorTaskTemplateSave, mentorTaskTemplateDelete, mentorSearchCoach, mentorTaskPublish, mentorNoticeRules, mentorNoticeRuleSave, mentorAdminRelations } from '@/api/mentor'
import { ElMessage, ElMessageBox } from 'element-plus'

export default {
  name: 'MentorTaskManage',
  data () {
    return {
      loading: false, total: 0, tableData: [],
      query: { page: 1, size: 10, title: '', publisherName: '', receiverName: '' },
      detailVisible: false, detailLoading: false, detailList: [], subVisible: false, subRecord: null,
      operatorId: Number(localStorage.getItem('sysUserId') || localStorage.getItem('userId') || 1),
      tplVisible: false, tplLoading: false, tplList: [],
      tplFormVisible: false, tplSaving: false,
      tplForm: { id: null, title: '', taskType: 1, targetStageMonths: [], content: '', sort: 0 },
      publishVisible: false, publishing: false, coachLoading: false, receiverOptions: [], relationOptions: [],
      publishForm: { tplId: null, title: '', content: '', taskType: 1, targetStageMonths: [], deadline: null, mode: 'individual', receiverIds: [], relationIds: [] },
      ruleVisible: false, ruleLoading: false, ruleSaving: false, ruleList: []
    }
  },
  computed: {
    formDataRows () {
      if (!this.subRecord || !this.subRecord.submission || !this.subRecord.submission.formData) return []
      try {
        const obj = JSON.parse(this.subRecord.submission.formData)
        if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
          return Object.keys(obj).map(k => ({ k, v: typeof obj[k] === 'object' ? JSON.stringify(obj[k]) : obj[k] }))
        }
      } catch (e) { /* ignore */ }
      return []
    },
    // ===== 提交附件解析：fileUrl / fileName 均为逗号分隔，按索引一一对应 =====
    attachItems () {
      if (!this.subRecord || !this.subRecord.submission || !this.subRecord.submission.fileUrl) return []
      const urls = String(this.subRecord.submission.fileUrl).split(',').map(s => s.trim()).filter(Boolean)
      const names = this.subRecord.submission.fileName ? String(this.subRecord.submission.fileName).split(',') : []
      return urls.map((url, i) => ({
        url,
        name: (names[i] && names[i].trim()) || this.urlBasename(url),
        isImage: /\.(png|jpe?g|gif|webp|bmp)(\?|#|$)/i.test(url)
      }))
    },
    attachImageUrls () { return this.attachItems.filter(f => f.isImage).map(f => f.url) },
    attachDocItems () { return this.attachItems.filter(f => !f.isImage) }
  },
  mounted () { this.load() },
  methods: {
    async load () {
      this.loading = true
      const params = { page: this.query.page, size: this.query.size }
      if (this.query.title) params.title = this.query.title
      if (this.query.publisherName) params.publisherName = this.query.publisherName
      if (this.query.receiverName) params.receiverName = this.query.receiverName
      const r = await mentorAdminTasks(params)
      this.loading = false
      if (r && r.code === 200) { this.tableData = r.data.records || []; this.total = r.data.total || 0 }
      else ElMessage.warning((r && r.message) || '查询失败')
    },
    onPage (p) { this.query.page = p; this.load() },
    onSize (s) { this.query.size = s; this.query.page = 1; this.load() },
    search () { this.query.page = 1; this.load() },
    reset () {
      this.query.title = ''
      this.query.publisherName = ''
      this.query.receiverName = ''
      this.query.page = 1
      this.load()
    },
    recvStatus (s) { return ['待接收', '已接收', '退回待提交', '已提交', '已审核', '延期未操作'][s] || s },
    reviewStatusText (s) { return ['待审核', '通过', '驳回', '免审'][s] || s },
    submitTypeText (t) { return ['', '文档', '图片', '表单', '文本'][t] || ('类型' + t) },
    monthsText (arr) {
      if (!arr) return '通用'
      const list = String(arr).split(',').filter(Boolean).map(Number)
      if (!list.length) return '通用'
      return list.sort((a, b) => a - b).map(m => '第' + m + '月').join('、')
    },
    periodStageText (row) {
      const period = row.period || (row.relation && this.periodFromPair(row.relation.pairDate))
      const stage = row.stageMonth || (row.relation && this.monthsFromPair(row.relation.pairDate))
      if (!period) return this.stageLabel(stage)
      return period + '期·' + this.stageLabel(stage)
    },
    stageLabel (s) { if (!s || s <= 0) return '-'; if (s > 12) return '已满期(' + s + '个月)'; return '第' + s + '个月' },
    periodFromPair (d) { if (!d) return null; return new Date(d).getFullYear() },
    monthsFromPair (d) { if (!d) return 0; const p = new Date(d); const n = new Date(); return Math.max((n.getFullYear() - p.getFullYear()) * 12 + (n.getMonth() - p.getMonth()) + 1, 1) },
    fmtTime (t) { if (!t) return ''; return String(t).replace('T', ' ').substring(0, 16) },
    urlBasename (u) {
      try { return decodeURIComponent(String(u).split('?')[0].split('/').pop() || u) } catch (e) { return u }
    },
    async urgeSubmit (taskId) {
      const r = await mentorNoticeUrgeSubmit({ taskId, operatorId: this.operatorId })
      ElMessage.info((r && r.message) || (r && r.code === 200 ? '已推送' : '推送失败'))
    },
    async urgeOverdue () {
      const r = await mentorNoticeUrgeOverdue({ operatorId: this.operatorId })
      ElMessage.info((r && r.message) || (r && r.code === 200 ? '已推送' : '推送失败'))
    },
    async summary () {
      const r = await mentorNoticeSubmitSummary({ operatorId: this.operatorId })
      ElMessage.info((r && r.message) || (r && r.code === 200 ? '已推送' : '推送失败'))
    },
    async goDetail (taskId) {
      this.detailVisible = true; this.detailLoading = true; this.detailList = []
      const r = await mentorAdminTaskReceivers({ taskId })
      this.detailLoading = false
      if (r && r.code === 200) this.detailList = r.data || []
      else ElMessage.warning((r && r.message) || '查询失败')
    },
    viewSubmission (row) { this.subRecord = row; this.subVisible = true },
    // ============ 任务模板库（B2）============
    async loadTpls () {
      this.tplLoading = true
      const r = await mentorTaskTemplates({ page: 1, size: 100 })
      this.tplLoading = false
      if (r && r.code === 200 && r.data) this.tplList = r.data.records || []
      else ElMessage.warning((r && r.message) || '模板加载失败')
    },
    resetTplForm () {
      this.tplForm = { id: null, title: '', taskType: 1, targetStageMonths: [], content: '', sort: 0 }
      this.tplFormVisible = true
    },
    editTpl (row) {
      this.tplForm = {
        id: row.id, title: row.title, taskType: row.taskType || 1,
        targetStageMonths: row.targetStageMonths ? String(row.targetStageMonths).split(',').filter(Boolean).map(Number) : [],
        content: row.content || '', sort: row.sort || 0
      }
      this.tplFormVisible = true
    },
    async saveTpl () {
      if (!this.tplForm.title) { ElMessage.warning('请填写模板标题'); return }
      this.tplSaving = true
      const payload = { ...this.tplForm, targetStageMonths: (this.tplForm.targetStageMonths || []).join(',') || null }
      const r = await mentorTaskTemplateSave(payload)
      this.tplSaving = false
      if (r && r.code === 200) { ElMessage.success('已保存'); this.tplFormVisible = false; this.loadTpls() }
      else ElMessage.warning((r && r.message) || '保存失败')
    },
    async delTpl (row) {
      try {
        await ElMessageBox.confirm('确认删除模板「' + row.title + '」？', '提示', { type: 'warning' })
        const r = await mentorTaskTemplateDelete({ id: row.id })
        if (r && r.code === 200) { ElMessage.success('已删除'); this.loadTpls() }
        else ElMessage.warning((r && r.message) || '删除失败')
      } catch (e) { /* 取消 */ }
    },
    // ============ 下发任务 ============
    async openPublish () {
      this.publishForm = { tplId: null, title: '', content: '', taskType: 1, targetStageMonths: [], deadline: null, mode: 'individual', receiverIds: [], relationIds: [] }
      this.receiverOptions = []; this.relationOptions = []
      this.publishVisible = true
      this.loadTpls()
      // 预加载结对列表（用于按对批量下发）
      const r = await mentorAdminRelations({ page: 1, size: 200 })
      if (r && r.code === 200) this.relationOptions = r.data.records || []
    },
    applyTpl (tplId) {
      const t = this.tplList.find(x => x.id === tplId)
      if (t) {
        this.publishForm.title = t.title
        this.publishForm.content = t.content || ''
        this.publishForm.taskType = t.taskType || 1
        this.publishForm.targetStageMonths = t.targetStageMonths ? String(t.targetStageMonths).split(',').filter(Boolean).map(Number) : []
      }
    },
    async searchReceiver (kw) {
      if (!kw) return
      this.coachLoading = true
      const r = await mentorSearchCoach({ name: kw })
      this.coachLoading = false
      if (r && r.code === 200 && r.data) this.receiverOptions = Array.isArray(r.data) ? r.data : (r.data.records || [])
    },
    async doPublish () {
      const f = this.publishForm
      if (!f.title) { ElMessage.warning('请填写标题'); return }
      let relationIds = null, receiverIds = null
      if (f.mode === 'pair') {
        if (!f.relationIds || !f.relationIds.length) { ElMessage.warning('请选择至少一对师徒'); return }
        relationIds = f.relationIds.join(',')
      } else {
        if (!f.receiverIds || !f.receiverIds.length) { ElMessage.warning('请选择接收人'); return }
        receiverIds = f.receiverIds.join(',')
      }
      this.publishing = true
      const params = {
        title: f.title, taskType: f.taskType, content: f.content,
        publisherId: this.operatorId, publisherType: 2, deadline: f.deadline,
        targetStageMonths: (f.targetStageMonths || []).join(',') || null,
        relationIds, receiverIds
      }
      const r = await mentorTaskPublish(params)
      this.publishing = false
      if (r && r.code === 200) {
        ElMessage.success('任务已下发，接收人 ' + (r.data ? r.data.receiverCount : 0) + ' 人')
        this.publishVisible = false; this.load()
      } else {
        ElMessage.warning((r && r.message) || '下发失败')
      }
    },
    // ============ 催办漏斗规则（B4）============
    async openRules () {
      this.ruleVisible = true; this.ruleLoading = true
      const r = await mentorNoticeRules()
      this.ruleLoading = false
      if (r && r.code === 200) this.ruleList = r.data || []
      else ElMessage.warning((r && r.message) || '规则加载失败')
    },
    async saveRules () {
      this.ruleSaving = true
      for (const rule of this.ruleList) {
        const r = await mentorNoticeRuleSave(rule)
        if (!r || r.code !== 200) { this.ruleSaving = false; ElMessage.warning((r && r.message) || '保存失败：' + rule.ruleName); return }
      }
      this.ruleSaving = false
      ElMessage.success('规则已保存'); this.ruleVisible = false
    }
  }
}
</script>

<style scoped>
:deep(.el-card) { border-radius: 12px; box-shadow: 0 2px 8px rgba(31, 45, 61, .08); }
:deep(.el-card__header) { font-weight: 600; background: #fafbfc; border-radius: 12px 12px 0 0; }
:deep(.el-button) { border-radius: 6px; }
.sub-title { font-weight: 600; font-size: 14px; margin-bottom: 6px; color: #303133; }

/* ===== 提交内容弹窗 ===== */
.sub-dialog :deep(.el-descriptions__label) { width: 96px; }
.sub-dialog :deep(.el-descriptions__body .el-descriptions__cell) { word-break: break-all; }
.pre-wrap { white-space: pre-wrap; word-break: break-word; }
.attach-list { display: flex; flex-direction: column; gap: 8px; }
.attach-imgs { display: flex; flex-wrap: wrap; gap: 8px; }
.attach-thumb {
  width: 64px; height: 64px; border-radius: 8px;
  border: 1px solid #e4e7ed; cursor: zoom-in;
  transition: box-shadow .2s, transform .2s;
}
.attach-thumb:hover { box-shadow: 0 2px 10px rgba(0, 0, 0, .15); transform: translateY(-1px); }
.attach-file a {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 5px 10px; border-radius: 6px; text-decoration: none;
  background: #f5f7fa; border: 1px solid #ebeef5;
  transition: background .2s, border-color .2s;
}
.attach-file a:hover { background: #ecf5ff; border-color: #c6e2ff; }
.attach-file__name { color: #303133; font-size: 13px; max-width: 380px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.attach-file__open { color: #409eff; font-size: 12px; flex-shrink: 0; }
</style>
